const NOTIFICATION_TYPE = {
  WARNING: 'toast_warning',
  ERROR: 'toast_error',
  SUCCESS: 'toast_success',
  DEFAULT: 'toast_default',
  ORDER_CONFIRMATION: 'pinkShade'
};

const CLICK_TYPE = {
  LINK: 'link'
};

export { NOTIFICATION_TYPE, CLICK_TYPE };
